/**
 * Groups SKU rows by namespace, preserving the API's stable order
 * (ORDER BY vendor, slug, model) both across namespaces and within each.
 */
export function groupSkusByNamespace<
  T extends {
    readonly sku: {
      readonly namespace_slug: string;
      readonly namespace_id: string;
      readonly vendor: string;
    };
  },
>(rates: readonly T[]): readonly {
  readonly namespaceSlug: string;
  readonly namespaceId: string;
  readonly vendor: string;
  readonly skus: readonly T[];
}[] {
  const order: string[] = [];
  const buckets = new Map<string, T[]>();
  for (const rate of rates) {
    const existing = buckets.get(rate.sku.namespace_slug);
    if (existing === undefined) {
      order.push(rate.sku.namespace_slug);
      buckets.set(rate.sku.namespace_slug, [rate]);
    } else {
      existing.push(rate);
    }
  }
  return order.map((slug) => {
    const skus = buckets.get(slug) ?? [];
    return {
      namespaceSlug: slug,
      namespaceId: skus[0]?.sku.namespace_id ?? '',
      vendor: skus[0]?.sku.vendor ?? '',
      skus,
    };
  });
}
